
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import PresidentMessage from './components/PresidentMessage';
import ServicesSection from './components/ServicesSection';
import WorksSection from './components/WorksSection';
import ContactSection from './components/ContactSection';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <PresidentMessage />
        <ServicesSection />
        <WorksSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
